import { useConfigStore } from '@/store/config.store';
import { storeToRefs } from 'pinia';
import { computed, type ComputedRef } from 'vue';
import type { Product } from '@/domain/product/Product';

// Carries the invariant EditorView's `v-if="isStoreInitialized"` already enforces at runtime but
// the type system does not: under that gate, a product is loaded. Every caller sits below it, and
// initStore sets the flag only after the product resolves.
//
// Reading through here rather than through a store projection is what removes the `?? ''` / `?? 0`
// those projections used to buy their non-nullness with. An invented label reads like a label; an
// invented width reaches postPdfExport as a document of zero millimetres.
function useLoadedProduct(): ComputedRef<Product> {
    const { product } = storeToRefs(useConfigStore());

    return computed(() => {
        if (!product.value) {
            throw new Error('useLoadedProduct: no product is loaded. Callers must sit under the initialised editor.');
        }

        return product.value;
    });
}

export { useLoadedProduct };
